/**
 * B1-only opt-out for the Japanese quiz-answer subtext.
 *
 * Visual: pill-button mirroring the level-selector strip (App.tsx) so it
 * reads as part of the same control vocabulary. aria-pressed reflects state.
 */
import { showL1QuizTranslations } from '../i18n/learner.js';

export function L1QuizToggle() {
  const on = showL1QuizTranslations.value;
  const toggle = () => {
    showL1QuizTranslations.value = !showL1QuizTranslations.value;
  };
  return (
    <div className="max-w-4xl mx-auto px-4 pt-3">
      <button
        type="button"
        onClick={toggle}
        aria-pressed={on}
        className={`px-4 py-1.5 rounded-full text-sm font-semibold whitespace-nowrap transition-all ${
          on
            ? 'bg-primary-500 text-white shadow-1'
            : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
        }`}
      >
        <span aria-hidden="true">🇯🇵</span>{' '}
        {on ? 'Japanese hints on' : 'Japanese hints off'}
      </button>
    </div>
  );
}
